import React from 'react';
import CategorySkin from './Skins/CategorySkin/index.js';
import GameSkinV2 from './Skins/GameSkinV2/index.js';
import GameSkin from './Skins/GameSkin/index.js';

const Card = ({
  id,
  href,
  title,
  subtitle,
  imageLayers,
  customizedLayers,
  additionalInfo,
  size,
  type = "GAME",
  index,
  showPlaceholder = true,
  optimizedSrc,
  className,
  style,
  ...props
}) => {
  if (type === "CATEGORY") {
    return /* @__PURE__ */ React.createElement(
      CategorySkin,
      {
        id,
        href,
        title,
        subtitle,
        imageLayers,
        customizedLayers,
        additionalInfo,
        className,
        style,
        size,
        index,
        type,
        showPlaceholder,
        ...props
      }
    );
  }
  if (type === "GAME_V2" || type === "GAME_V2_SMALL") {
    return /* @__PURE__ */ React.createElement(
      GameSkinV2,
      {
        id,
        href,
        title,
        subtitle,
        imageLayers,
        customizedLayers,
        additionalInfo,
        className,
        style,
        size,
        index,
        type,
        optimizedSrc,
        showPlaceholder,
        ...props
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    GameSkin,
    {
      id,
      href,
      title,
      subtitle,
      imageLayers,
      customizedLayers,
      additionalInfo,
      className,
      style,
      size,
      index,
      showPlaceholder,
      optimizedSrc,
      type,
      ...props
    }
  );
};
Card.displayName = "Card";

export { Card };
//# sourceMappingURL=index.js.map
